import prestashop from "prestashop";
import { createComponent } from "@front/utils/alpine";
import { buildFormData } from "@front/utils";

export default createComponent(({ $persist, $defaults }) => ({
    controller: new AbortController(),

    async remove (url: string) {
        this.controller ? this.controller.abort() : null;
        this.controller = new AbortController();
        const { signal } = this.controller;

        const opts = {
            signal,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
            },
            body: buildFormData({
                ajax: '1',
                action: 'update',
            }),
        };

        const response = await fetch(url, opts);
        const resp = await response.json();

        prestashop.emit('updateCart', { resp });
    },
}));
